export const UPLOAD_FILE_LIMIT_TOTAL = 20;
export const FILE_TYPE_UPLOAD_ALLOWED = 'PDF,JPG,JPEG,PNG';
export const UPLOAD_LIMIT_SIZE_PER_FILE_BYTE = 50_000_000;
export const UPLOAD_LIMIT_SIZE_PER_FILE_UNIT = 'MB';
export const UPLOAD_LIMIT_SIZE_PER_FILE = `${
  UPLOAD_LIMIT_SIZE_PER_FILE_BYTE / 1_000_000
}${UPLOAD_LIMIT_SIZE_PER_FILE_UNIT}`;
export const ALLOWED_FILE_TYPES =
  'application/pdf, image/png, image/jpeg, image/jpg';
export const MAX_UPLOAD_SIZE_BYTE = 50_000_000 * 10; // 500MB
export const MAX_UPLOAD_SIZE_BYTE_SIZE = `${
  MAX_UPLOAD_SIZE_BYTE / 1_000_000
}${UPLOAD_LIMIT_SIZE_PER_FILE_UNIT}`;
